import * as React from "react";

import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Divider,
	DialogProps,
	useMediaQuery,
} from "@material-ui/core";
import {
	useTheme,
	withStyles,
	WithStyles,
	createStyles,
	Theme,
} from "@material-ui/core/styles";

// Classes
import Utility from "../../domain/classes/Utility";

// NPM
import clsx from "clsx";

export const styles = (theme: Theme) => createStyles({ root: {} });

export interface GenericDialogProps extends DialogProps {
	title: string;
	content: React.ReactNode;
	actions: React.ReactNode;
}

const GenericDialog = React.forwardRef<
	HTMLDialogElement,
	GenericDialogProps & WithStyles<typeof styles>
>(({ title, content, actions, classes, className, ...dialogProps }, ref) => {
	const theme = useTheme();
	const matchXs = useMediaQuery(theme.breakpoints.down("xs"));

	return (
		<Dialog
			ref={ref}
			{...dialogProps}
			className={clsx(classes.root, className)}
			fullScreen={matchXs}
		>
			<DialogTitle>{title}</DialogTitle>
			<Divider />
			<DialogContent>{content}</DialogContent>
			<Divider />
			<DialogActions>{actions}</DialogActions>
		</Dialog>
	);
});

export default withStyles(styles, {
	classNamePrefix: Utility.generateClassName("GenericDialog"),
})(GenericDialog);
